<template>
  <client-only>
    <v-select
      v-model="model"
      :items="items"
      :label="!model ? displayUsersBirthYear : formLabel"
      solo
      outlined
      rounded
      clearable
      :class="fieldClass"
      :menu-props="{contentClass:'smart-combo scrollbar-17',maxHeight:'200'}"
      dense
    />
  </client-only>
</template>

<script>
export default {
  props: {
    fieldClass: {
      type: String,
      required: false,
      default: ''
    },
    currentBirthYear: {
      type: Number
    }
  },
  data() {
    return {
      select: null,
      formLabel: 'בחר שנת לידה (לא חובה)',
      items: undefined
    }
  },

  computed: {
    model: {
      get() {
        return this.currentBirthYear
      },
      set(val) {
        this.select = val
      }
    },

    displayUsersBirthYear() {
      return this.currentBirthYear ? this.currentBirthYear : this.formLabel
    }
  },

  watch: {
    model() {
      if (this.model) {
        this.select = this.model
      }
    },
    select() {
      this.$emit('yearSelected', this.select)
    }
  },
  mounted() {
    this.seedDates()
  },

  methods: {
    seedDates() {
      const currentYear = new Date().getFullYear() - 16
      const minYear = new Date().getFullYear() - 100
      const arr = []

      for (var i = currentYear; i >= minYear; i--) {
        arr.push(i)
      }

      this.items = arr
    }
  }
}
</script>
